import React, { useState, useContext, useEffect } from "react";
import { getMonth, getWeek } from "../util";
import CalendarHeader from "./CalendarHeader";
import Sidebar from "./Sidebar";
import Month from "./Month";
import Week from "./Week";
import GlobalContext from "../context/GlobalContext";
import EventModal from "./EventModal";
import * as api from '../api/index';

function Home() {
  const [currenMonth, setCurrentMonth] = useState(getMonth());
  const [currentWeek, setCurrentWeek] = useState(getWeek());
  const { monthIndex, showEventModal, showWeekTab} = useContext(GlobalContext);

  const { setSavedEvents } = useContext(GlobalContext);

  async function getAllEvents() {
    try {
      const { data } = await api.GetAllEvents();
      return data.result;
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getAllEvents().then((data) => setSavedEvents(data));
  }, []);

  useEffect(() => {
    setCurrentMonth(getMonth(monthIndex));
  }, [monthIndex]);

  // useEffect(()=>{
  //   setCurrentWeek(getWeek(currentWeek));
  // }, [currentWeek])

  return (
    <React.Fragment>
      {showEventModal && <EventModal />}
      <div className="flex-columns">
        <CalendarHeader />
        <div className="flex-rows-start">
          <Sidebar />
          {showWeekTab ? (
            <Week week={currentWeek}></Week>
          ) : (
            <Month month={currenMonth} />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Home;
